import {
  addMonths,
  endOfMonth,
  format,
  startOfDay,
  startOfMonth,
} from 'date-fns';
import { Employment } from '../../models/employment';
import { dbDayDateToken } from '../../../static/dbDayDateToken';

export function getEmploymentRangeQuery(
  range: string,
): Mongo.Selector<Employment> {
  if (range === 'ALL') {
    return {};
  }
  const $and: Mongo.Selector<Employment>[] = [];
  let splitRange = range.split(',');
  switch (splitRange[0]) {
    case 'TODAY': {
      $and.push({
        startDate: { $lte: format(new Date(), dbDayDateToken) },
        endDate: { $gte: format(new Date(), dbDayDateToken) },
      });
      break;
    }
    case 'MONTH': {
      const monthStart = startOfDay(startOfMonth(new Date()));
      const monthEnd = startOfDay(endOfMonth(new Date()));
      $and.push(checkIfEmploymentInRange(monthStart, monthEnd));
      break;
    }
    case 'NEXT_MONTH': {
      const monthStart = startOfDay(startOfMonth(addMonths(new Date(), 1)));
      const monthEnd = startOfDay(endOfMonth(addMonths(new Date(), 1)));
      $and.push(checkIfEmploymentInRange(monthStart, monthEnd));
      break;
    }
    case 'CUSTOM': {
      if (splitRange[1] && splitRange[2]) {
        const rangeStart = new Date(splitRange[1]);
        const rangeEnd = new Date(splitRange[2]);
        $and.push(checkIfEmploymentInRange(rangeStart, rangeEnd));
      }
      break;
    }
  }
  return {
    $and,
  };
}

function checkIfEmploymentInRange(
  monthStart: Date,
  monthEnd: Date,
): Mongo.Selector<Employment> {
  return {
    $or: [
      {
        // startDate is in timespan
        startDate: {
          $gte: format(monthStart, dbDayDateToken),
          $lte: format(monthEnd, dbDayDateToken),
        },
      },
      {
        // endDate is in timespan
        endDate: {
          $lte: format(monthEnd, dbDayDateToken),
          $gte: format(monthStart, dbDayDateToken),
        },
      },
      {
        // timespan contains start&endDate
        startDate: { $lte: format(monthStart, dbDayDateToken) },
        endDate: { $gte: format(monthEnd, dbDayDateToken) },
      },
    ],
  };
}
